import { UxAction, UxModal, UxPriorityEnum, UxStyleEnum } from "@imaginelearning/mps-ux-component-library";
import { useTranslation } from "react-i18next";

interface UnauthorizedQuizModalProps {
  showErrorDialog: boolean;
  setShowErrorDialog: Function;
}

export default function UnauthorizedQuizModal({
  showErrorDialog,
  setShowErrorDialog
}: Readonly<UnauthorizedQuizModalProps>) {
  const { t } = useTranslation();
  return (
    <UxModal
      showModal={showErrorDialog}
      showClose={false}
      handleClose={() => {
        setShowErrorDialog(false);
      }}
      title={t("unauthorized-quiz-modal-title")}
      backdrop="static"
      body={<span>{t("unauthorized-quiz-modal-message")}</span>}
      footer={[
        <UxAction
          key={1}
          enabled={true}
          text={t("unauthorized-quiz-modal-close")}
          priority={UxPriorityEnum.INFO}
          callback={() => {
            setShowErrorDialog(false);
          }}
          style={UxStyleEnum.ROUNDED}
          className="px-3"
        />,
        <UxAction
          key={0}
          enabled={true}
          text={t("unauthorized-quiz-modal-reload")}
          priority={UxPriorityEnum.SUCCESS}
          callback={() => {
            window.location.reload();
          }}
          style={UxStyleEnum.ROUNDED}
          className="px-3"
        />
      ]}
    />
  );
}
